"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M20.45,6.54H2.92a.6.6,0,0,1,0-1.21H20.45a.6.6,0,0,1,0,1.21Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5.55,3.74A.44.44,0,1,0,6,4.18a.44.44,0,0,0-.44-.44Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M7.3,3.74a.44.44,0,1,0,.44.44.44.44,0,0,0-.44-.44Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M9.06,3.74a.44.44,0,1,0,.44.44.44.44,0,0,0-.44-.44Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.81,17.05H4.68A2.36,2.36,0,0,1,2.32,14.7V4.18A2.36,2.36,0,0,1,4.68,1.83h14a2.36,2.36,0,0,1,2.36,2.36v7a.6.6,0,0,1-1.21,0v-7A1.15,1.15,0,0,0,18.69,3h-14A1.15,1.15,0,0,0,3.53,4.18V14.7a1.15,1.15,0,0,0,1.15,1.15h6.13a.6.6,0,0,1,0,1.21Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M15.63,21.08a1.1,1.1,0,1,0,2.19,0Zm4.89-2.31V15.56a3.79,3.79,0,0,0-2.91-3.69v-.4a.88.88,0,0,0-1.75,0v.4a3.79,3.79,0,0,0-2.91,3.69v3.21l-1.17,1.17v.58h9.92v-.58Z"
  })));
};

exports["default"] = _default;